import React from "react";
import UserListModal from "./UserListModal";
import { MODAL_IDS } from "./profile-constants";

function FollowingModal({ users, isOpen, onClose }) {
  return (
    <UserListModal
      id={MODAL_IDS.FOLLOWING}
      title="Стежить"
      ariaLabel="Список підписок"
      users={users}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
}

export default FollowingModal;
